import { Navigate, useParams } from "react-router-dom";
import { QR_TARGETS, ROUTES } from "@/config/routes";

export default function QrRedirect() {
  const { code } = useParams();
  return <Navigate to={QR_TARGETS[code] || ROUTES.home} replace />;
}
